import React, { useEffect, useState } from 'react';
import styles from './WeatherForecastText.module.css'; // Import CSS file for styling
import { useDispatch, useSelector } from 'react-redux';
import Accordion from '../ui/Accordion';
import { getGeospheredataplatformdata } from '../../../actions';
import {
  forecastTextMapping,
  forecastTextMappingEnglisch,
} from '../../../constants/WeatherforecastHelper';

const WeatherForecastText = ({ forecasttext, selName }) => {
  const alltexts = useSelector((state) =>
    state.geospheredataplatformdata
      ? state.geospheredataplatformdata[forecasttext]
      : {},
  );
  const language = useSelector(
    (state) => state.geospheredataplatformdata['SET_LANGUAGE'],
  );
  const [showText, setShowText] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowText(true);
    }, 5000);

    // Cleanup the timer when the component unmounts
    return () => clearTimeout(timer);
  }, []);

  const selectStation = Object.values(forecastTextMapping)[selName];
  const selNameLng = Object.keys(forecastTextMapping)[selName];
  const selNameEnLng = Object.keys(forecastTextMappingEnglisch)[selName];
  const regionName = language === 'de' ? selNameLng : selNameEnLng;
  const title =
    language === 'de'
      ? ['Wetterprognose', 'Bergprognose']
      : ['Weather forecast', 'Mountain forecast'];
  return (
    <div className={styles.weatherInfo}>
      {selectStation && alltexts?.data && alltexts?.data.length > 0 ? (
        <Accordion
          items={alltexts?.data.filter((i) => i.stationid == selectStation)}
          columns={alltexts?.data.some(
            (i) => i.stationid == selectStation && i.textmarken_id == 615,
          )}
          titleAllg={title}
          region={regionName}
        />
      ) : (
        <>
          {showText && (
            <p>
              Achtung! Aufgrund von Problemen, werden derzeit keine
              Prognosetexte angezeigt!!!{' '}
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default WeatherForecastText;
